import styled from "styled-components";

export const Container = styled.div`
  width: 350px;
  height: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 16px;
  left: 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.07), 0 2px 6px 0 rgba(0, 0, 0, 0.10);
  overflow: hidden;
  z-index: 2;
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BottomContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  gap: 12px;

  .tagNew {
    width: 78px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.primary.primaryContainer}, ${theme.colors.surface.surface})`};

    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.primary.primary};
  }
  
  .titleContainer {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .title {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }
  
    .description {
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }
  }
  
  .buttonContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      height: 32px;
    }
  }
`;
